import { createContext, useContext, useEffect, useState } from "react";
import { api, getToken, setToken, clearToken } from "@/lib/adminApi";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  // null = comprobando, false = no autenticado, objeto = autenticado
  const [admin, setAdmin] = useState(null);

  useEffect(() => {
    if (!getToken()) {
      setAdmin(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setAdmin(r.data))
      .catch(() => {
        clearToken();
        setAdmin(false);
      });
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setToken(data.access_token);
    setAdmin(data.user);
  };

  const logout = () => {
    clearToken();
    setAdmin(false);
  };

  return (
    <AuthContext.Provider value={{ admin, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
